import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { regiaoSituacaoAtiva, regiaoSituacaoInativa } from '../regiao-situacao';

@Component({
    selector: 'sgt-regiao-situacao-multiselect',
    templateUrl: './regiao-situacao-multiselect.component.html',
    styleUrls: ['./regiao-situacao-multiselect.component.less']
})
export class RegiaoSituacaoMultiselectComponent implements OnInit {
    /** Situações selecionadas */
    @Input() situacoes: number[];
    /** Ao alterar a seleção das situações */
    @Output() situacoesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma situação';
    @Input() checked = 'Situação'
    @Input() checkedPlural = 'Situações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas selecionadas';
    @Input() searchEmptyResult = 'Nenhuma situação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowAtiva = true;
    @Input() isShowInativa = true;
    // Options
    options: IMultiSelectOption[];


    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-regiao-situacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as situações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowAtiva) {
            selects.push({
                id: regiaoSituacaoAtiva.id,
                name: regiaoSituacaoAtiva.nome,
                classes: 'multiselect-item-regiao-situacao multiselect-item-regiao-situacao-ativa'
            });
        }
        if (this.isShowInativa) {
            selects.push({
                id: regiaoSituacaoInativa.id,
                name: regiaoSituacaoInativa.nome,
                classes: 'multiselect-item-regiao-situacao multiselect-item-regiao-situacao-inativa'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das situações */
    onChange() {
        this.situacoesChange.emit(this.situacoes);
    }
}
